<template>
  <div class="search-actions">
    <div class="action-btns">
      <TolAltButton
        label="Export to excel"
        icon-name="file-excel"
        @click="displayExportOptions = !displayExportOptions"
      />

      <Dropdown
        v-if="displayExportOptions"
        :menu-items="[
          { label: $t('advancedSearch.actions.exportAll') },
          { label: $t('advancedSearch.actions.exportPage') }
        ]"
        class="dropdown-menu-right right-anchored"
        @optionClicked="onMenuOptionSelected($event)"
      />
    </div>
  </div>
</template>

<script>
import TolAltButton from '@/app/components/TolAltButton';
import Dropdown from '@/app/components/Dropdown';
import vClickOutside from 'v-click-outside';

import { AdvancedSearchActions } from '@/app/features/advanced-search/advanced-search.keys';
export default {
  name: 'SearchExportActions',
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    Dropdown,
    TolAltButton
  },
  data() {
    return {
      displayExportOptions: false
    };
  },
  methods: {
    onMenuOptionSelected(val) {
      this.displayExportOptions = false;
      this.$store.dispatch(AdvancedSearchActions.DownloadSearchResultsAsExcel, val.menuOption);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors';
@import '@/app/styles/variables';

.search-actions {
  display: flex;
  padding: 60px;
  background-color: $background-level-2;
  justify-content: flex-end;
  .action-btns {
    position: relative;
    display: flex;
    justify-content: space-between;
  }
}

.right-anchored {
  right: 0;
}
</style>
